import React, { Component } from 'react';
import './style.scss';
import Foleders from './components/Folders/Foleders';
import PresentationItems from './components/PresentationItems/PresentationItems';
import { connect } from 'react-redux'
import { showModal, MODAL_VIDE_INFO } from '../../modules/modals';

class Presentations extends Component {
  componentDidMount(){
    if(!localStorage.getItem('view_video_info_presentation')){
      localStorage.setItem('view_video_info_presentation', 1)
      this.props.showModal({
        modalType : MODAL_VIDE_INFO,
        modalProps : {
          titleModal: 'txtTitleVideoInfoPresentations',
          messageModal: 'txtMessageVideoInfoPresentations',
          videoUrl: '/images/video_info/lecture_hall_tutorial.mp4'
        }
      })
    }
  }

  render() {
    
    console.log("Presentations -> render -> conn")
    return (
      <div className="qbm-content Presentations">
        <Foleders />
        <PresentationItems />
        <div className="video_btn" onClick={() => {
          this.props.showModal({
            modalType : MODAL_VIDE_INFO,
            modalProps : {
              titleModal: 'txtTitleVideoInfoPresentations',
              messageModal: 'txtMessageVideoInfoPresentations',
              videoUrl: './images/video_info/lecture_hall_tutorial.mp4'
            }
          })
        }}><i className="fas fa-question"></i></div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Presentations)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentations/Presentations.jsx